const Views = {};
Views.Base = Backbone.View.extend({});
module.exports = Views;



// WEBPACK FOOTER //
// ./view/view.js